import React from "react";
import moment from "moment/moment";

const SingleOrder = props => {
    
    this.formatedDate = date => {
        return (
            <td>
                <span className="mr-2">
                    {moment(date).format('DD MMM YYYY')}
                </span>
                <span className="ml-2">
                    {moment(date).format('HH:mm')}
                </span>
            </td>
        );
    };

    /*
    let iconMappings = {
        active_orders: 'active',
        pending: 'pending',
        inTransit: 'inTransit',
        ready: 'ready',
        cancelled: 'cancelled',
        deleted: 'deleted',
    };
    */

    let classComp = "order-status-dot order-status "+props.data.status;

    return (
        <tr className="clickable" onClick={() => props.openOrderDetails(props.data.id)}>
            <td>{props.data.id}</td>
            <td></td>
            <td>{props.data.user.name}</td>
            <td></td>
            {this.formatedDate(props.data.createdOn)}
            <td></td>
            {(props.data.completedOn !== undefined) ? this.formatedDate(props.data.completedOn) : <td> </td>}
            <td></td>
            <td><span className={classComp}></span> {props.data.status}</td>
        </tr>
    );
};

export default SingleOrder;



// WEBPACK FOOTER //
// ./src/customModules/Orders/components/single-order.js